// Module
var code = `{{#name}}
<div class="object-name dk-col-small-12">
   <h{{headlineLevel}} class="headline">
      <span>{{name}}</span>
   </h{{headlineLevel}}>
{{/name}}
<div class="object-images dk-col-small-12">
   <div class="slider dark">
      <div class="slides-container">
         {{#images}}
            <figure style="width: 100%; display: inline-block;">
               <img src='{{imagePath}}' title='{{image_name}}' alt='{{image_description}}'>
               <figcaption>{{textVariables.rights}} {{image_owner}} / {{image_creator}} ({{image_rights}})</figcaption>
            </figure>
         {{/images}}
      </div>
   </div>
</div>
<div class="icon-block dk-col-small-12 dk-hide-for-small dk-show-for-medium">
   <div class="dk-grid dk-small-align-right">
      <div class="dk-col-small-shrink">
         <a href="#" class="share"><i class="icon icon-teilen"></i></a>
         <div class="share-block">
            <a class="close" href="#" title="Teilen Übersicht schließen.">
               <i class="icon icon-schliessen"></i>
            </a>
            {{#shareLinks}}
               {{#links}}
                  <a href="{{link}}" title="Teilen auf {{link}}" class="{{visibility}}" target="_blank"><i class="icon icon-{{icon}}"></i></a>
               {{/links}}
            {{/shareLinks}}
         </div>
      </div>
   </div>
</div>
<div class="accordion-group special">
   {{#description}}
      <div class="accordion-group__accordion">
         <header class="accordion-group__accordion-head">
            <h{{headlineLevel2}} class="headline">
               <button type="button" class="accordion-group__accordion-btn">{{textVariables.about}}</button>
            </h{{headlineLevel2}}>
         </header>
         <div class="accordion-group__accordion-panel">
           <div class="accordion-group__accordion-content">
            <div class="object-description">
               <div class="dk-grid">
                  <div class="dk-col-small-12 dk-col-medium-6">
                     <div class="rte">
                        <p>{{{description}}}</p>
                     </div>
                  </div>

                  <div class="dk-col-small-12 dk-col-medium-6">
                     <div class="objektdaten dk-grid dk-small-align-justify">
                        {{#inventorynumber}}
                           <div class="dk-col-small-12 dk-col-large-8">{{textVariables.inventorynumber}}</div>
                           <div class="dk-col-small-12 dk-col-large-4">{{{inventorynumber}}}</div>
                        {{/inventorynumber}}
                        {{#material}}
                           <div class="dk-col-small-12 dk-col-large-8">{{textVariables.material}}</div>
                           <div class="dk-col-small-12 dk-col-large-4">{{{material}}}</div>
                        {{/material}}

                        {{#dimensions}}
                           <div class="dk-col-small-12 dk-col-large-8">{{textVariables.dimensions}}</div>
                           <div class="dk-col-small-12 dk-col-large-4">{{{dimensions}}}</div>
                        {{/dimensions}}
                        {{#inscription}}
                           <div class="dk-col-small-12 dk-col-large-8">{{textVariables.inscription}}</div>
                           <div class="dk-col-small-12 dk-col-large-4">{{{inscription}}}</div>
                        {{/inscription}}
                     </div>
                  </div>
               </div>
            </div>
         </div>
         </div>
      </div>
   {{/description}}

   <div class="accordion-group__accordion">
      <header class="accordion-group__accordion-head">
         <h{{headlineLevel2}} class="headline">
            <button type="button" class="accordion-group__accordion-btn">{{textVariables.classification}}</button>
         </h{{headlineLevel2}}>
      </header>
      <div class="accordion-group__accordion-panel">
        <div class="accordion-group__accordion-content">
         <div class="object-tags">
            <div class="dk-grid">
               <div class="tags event-tags dk-col-small-12 dk-col-medium-6">
                  {{#textVariables.classificationText}}
                     <p class="classification-text">{{textVariables.classificationText}}</p>
                  {{/textVariables.classificationText}}
                  <div class="tags-wrap">
                  {{#eventsObject}}
                     <fieldset class="dk-grid">
                        {{#event_type_name}}
                           <legend class="classification-type dk-col-small-12">{{event_type_name}}{{#event_note}} {{event_note}}{{/event_note}}</legend>
                        {{/event_type_name}}
                        {{#time}}
                           <div class="dk-col-small-shrink">
                              <input class="time" name='tag-events' id='tag-{{time_id}}' data-id='{{time_id}}' type='checkbox'>
                              <label for='tag-{{time_id}}' title="{{people_time_description}}">
                                 <span class="name">{{time_name}}{{#event_time_certain}} [circa]{{/event_time_certain}}</span>
                              </label>
                           </div>
                        {{/time}}
                        {{#people}}
                           <div class="dk-col-small-shrink">
                              <input class="people" name='tag-events' id='tag-{{people_id}}' data-id='{{people_id}}' type='checkbox' >
                              <label for='tag-{{people_id}}' title="{{people_short_description}}">
                                 <span class="name">{{displayname}}{{#event_people_certain}} [circa]{{/event_people_certain}}</span>
                              </label>
                           </div>
                        {{/people}}
                        {{#place}}
                           <div class="dk-col-small-shrink">
                              <input class="place" name='tag-events' id='tag-{{place_id}}' data-id='{{place_id}}' type='checkbox' >
                              <label for='tag-{{place_id}}' title="{{people_place_description}}">
                                 <span class="name">{{place_name}}{{#event_people_certain}} [circa]{{/event_people_certain}}</span>
                              </label>
                           </div>
                        {{/place}}
                     </fieldset>
                  {{/eventsObject}}
                  </div>
               </div>
               <div class="tags regular-tags dk-col-small-12 dk-col-medium-6">
                  <div class="tags-wrap">
                     <fieldset class="dk-grid">
                        {{#textVariables.tags}}
                        <legend class="dk-col-small-12">{{textVariables.tags}}</legend>
                        {{/textVariables.tags}}
                        {{#tags}}
                           <div class="dk-col-small-shrink">
                              <input name='tag' id='tag-{{tag_id}}' data-id='{{tag_id}}' type='checkbox'>
                              <label for='tag-{{tag_id}}' data-tag-note='{{tag_note}}' data-url='{{tag_url}}'>
                                 <span class="name">{{tag_name}}</span>
                                 {{#tag_occurences}}
                                 <span class="vertical-separator">|</span>
                                 <span class="count">{{tag_occurences}}</span>
                                 {{/tag_occurences}}
                              </label>
                           </div>
                        {{/tags}}
                     </fieldset>
                  </div>
               </div>
            </div>
            <div class="dk-grid dk-small-align-center">
               <button class="button primary hollow dk-col-small-shrink" disabled="disabled">{{textVariables.tagSearchButton}} <span class="count"></span></button>
            </div>
         </div>
      </div>
      </div>
   </div>
   {{#linksOrLiterature}}
      <div class="accordion-group__accordion">
          <header class="accordion-group__accordion-head">
            <h{{headlineLevel2}} class="headline">
               <button type="button" class="accordion-group__accordion-btn">{{textVariables.literature}}/{{textVariables.links}}</button>
            </h{{headlineLevel2}}>
          </header>
          <div class="accordion-group__accordion-panel">
            <div class="accordion-group__accordion-content">
               <div class="literature links">
                 
                  {{#literature.output}}
                     <ul class="literature-list no-bullets no-margin">
                        {{#literature.entries}}
                           <li>
                              <div class="rte">
                                 <p>{{literature_author}} ({{literature_year}}): {{literature_title}} {{literature_place_publisher}}{{#literature_inlit}}, {{literature_inlit}}{{/literature_inlit}}</p>
                              </div>
                           </li>
                        {{/literature.entries}}
                     </ul>
                  {{/literature.output}}

                  {{#links.output}}
                     <ul class="no-bullets no-margin">
                        {{#links.entries}}
                           <li>
                              <a href="{{link_text}}" class="iconleft light"><i class="icon icon-arrow-right"></i>{{link_display}}</a>
                           </li>
                        {{/links.entries}}
                     </ul>
                  {{/links.output}}
               </div>
            </div>
         </div>
      </div>
   {{/linksOrLiterature}}

   {{#mdlink}}
      <div class="accordion-group__accordion">
         <header class="accordion-group__accordion-head">
            <h{{headlineLevel2}} class="headline">
               <button type="button" class="accordion-group__accordion-btn">{{textVariables.mdlink}}</button>
            </h{{headlineLevel2}}>
         </header>
         <div class="accordion-group__accordion-panel">
           <div class="accordion-group__accordion-content">
            <div class="collections">
              
               <ul class="no-bullets no-margin">
                  <li>
                     <a href="{{mdlink}}" class="iconleft light"><i class="icon icon-arrow-right"></i>{{textVariables.mdlink-text}}: {{name}}</a>
                  </li>
               </ul>
            </div>
            </div>
         </div>
      </div>
   {{/mdlink}}

   {{#collections.output}}
   <div class="accordion-group__accordion">
      <header class="accordion-group__accordion-head">
         <h{{headlineLevel2}} class="headline">
            <button type="button" class="accordion-group__accordion-btn">{{textVariables.collections}}</button>
         </h{{headlineLevel2}}>
      </header>
      <div class="accordion-group__accordion-panel">
        <div class="accordion-group__accordion-content">
               <div class="collections">
                  <ul class="no-bullets no-margin">
                     {{#collections.entries}}
                     <li>
                        <a href="{{collection_url}}" class="iconleft light"><i class="icon icon-arrow-right"></i>{{collection_name}}</a>
                     </li>
                     {{/collections.entries}}
                  </ul>
               </div>
         </div>
      </div>
   </div>
   {{/collections.output}}

   {{#series}}
      <div class="accordion-group__accordion">
         <header class="accordion-group__accordion-head">
            <h{{headlineLevel2}} class="headline">
               <button type="button" class="accordion-group__accordion-btn">{{textVariables.series}} {{series_name}}</button>
            </h{{headlineLevel2}}>
         </header>
         <div class="accordion-group__accordion-panel">
           <div class="accordion-group__accordion-content">
            <div class="object-collections">
               
               <div class="collection-teaser dark" data-headline-level="{{headlineLevel3}}" data-ajax-url="{{search_url}}" data-current-search-value-param="&serie_id={{series_id}}" data-current-start-param="&startwert=0"
                  data-current-step-param="&gbreitenat=16" data-detail-url="{{detail_url}}" data-detail-link-text="{{textVariables.detailLinkText}}" data-show-counter="false">
                  <div class="slider-wrap">
                     <div class="slider">
                        <!--JS Output goes here-->
                     </div>
                     <div class="fastbackward-button dk-hide-for-small"><i class='icon icon-arrow-right'></i></div>
                     {{#series_overview_url}}
                        <a class="coll-link iconright light" href="{{series_overview_url}}">{{textVariables.seriesLinkText}} <i class='icon icon-arrow-right'></i></a>
                     {{/series_overview_url}}
                  </div>

               </div>
            </div>
            </div>
         </div>
      </div>
   {{/series}}

   {{#mdMap}}
      <div class="accordion-group__accordion">
         <header class="accordion-group__accordion-head">
            <h{{headlineLevel2}} class="headline">
               <button type="button" class="accordion-group__accordion-btn">{{textVariables.placeClassification}}</button>
            </h{{headlineLevel2}}>
         </header>
         <div class="accordion-group__accordion-panel">
           <div class="accordion-group__accordion-content">
            <div class="object-events">
              
               <div class="map">
                  <div class="map-wrapper">
                     <div class="dk-grid map">
                        <div class="dk-col-small-12">
                           <div id="map" class="map-container aspect-ratio-mobile-4 aspect-ratio-desktop-16" data-mapid="map" data-lat="{{latitude}}" data-lng="{{longitude}}" data-zoom-desktop="{{zoom}}" data-zoom-mobile="{{zoom}}">
                              {{#markers}}
                                 <div class="map-marker" data-lat="{{latitude}}" data-lng="{{longitude}}">
                                 </div>
                              {{/markers}}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         </div>
      </div>
   {{/mdMap}}
</div>
`;
// Exports
module.exports = code;